/** Suggested USD amounts for contribute / donate UI (cents). */
export const ONE_TIME_AMOUNT_PRESETS_CENTS = [500, 1000, 2500] as const;
